import { InternalURL } from "./internal-url";

export function createImporterStatusPageURL(importID: string) {
  const path = `/importer/status/${importID}`;

  return new InternalURL(path);
}
